import React from "react";
import { useRouteContext } from "@tanstack/react-router";
import { useThemeStore } from "@/store/theme";
import type { Theme } from "@/store/theme";

export function useTheme() {
  const context = useRouteContext({ from: "__root__" });
  const theme = useThemeStore((state) => state.theme);
  const mounted = useThemeStore((state) => state.mounted);
  const setTheme = useThemeStore((state) => state.setTheme);
  const toggleTheme = useThemeStore((state) => state.toggleTheme);

  const serverTheme: Theme =
    context &&
    typeof context === "object" &&
    "theme" in context &&
    (context.theme === "light" || context.theme === "dark")
      ? context.theme
      : "light";

  const currentTheme = mounted ? theme : serverTheme;

  return {
    theme: currentTheme,
    setTheme,
    toggleTheme,
    mounted,
  };
}

type ThemeProviderProps = {
  children: React.ReactNode;
  defaultTheme?: Theme;
};

export function ThemeProvider({
  children,
  defaultTheme = "light",
}: ThemeProviderProps) {
  const [initialized, setInitialized] = React.useState(false);

  // Initialize the store synchronously with the server theme
  if (!initialized) {
    const { setTheme, setMounted } = useThemeStore.getState();
    setTheme(defaultTheme);
    setMounted(true);
    setInitialized(true);
  }

  return <>{children}</>;
}
